(function ($) {
    function ShopifyFilter(element, params) {

        if (typeof element === 'string') {
            // The first parameter must be a DOM selector.
            this.initWithSelector(element, params);
        } else {
            // The first parameter must be a DOM element.
            this.initWithElement(element, params);
        }
    }

    ShopifyFilter.prototype = {
        DEBUG: true,
        element: null,
        cachePath: null,
        expiryOffset: 120000, // 2 minutes
        enableColourMappings: false,
        hideUnavailableProducts: true,
        hideUnavailableFilterOptions: false,
        colourMappings: null,
        colourOptionName: 'Colour',
        sizeMappings: {},
        products: [],
        productsFiltered: [],
        productsDisplayed: [],
        productTemplate: null,
        productsContainer: null,
        productCountElement: null,
        productsContainerSelector: null,
        scrollableContainer: null,
        filter: null,
        tagWhitelist: null,
        tagBlacklist: null,
        optionOrder: null,
        optionBlacklist: null,
        totalProducts: null,
        totalPages: null,
        totalPerPage: 24,
        maxPerPage: 250,
        pages: null,
        params: {
            page: 0,
            q: '',
            type: '',
            sort_by: ''
        },
        pageSet: false,
        pagination: {
            selector: null,
            element: null,
            nextText: null,
            prevText: null,
            optional: false
        },
        currencyPrefix: '$',

        // Methods
        onStart: $.noop,
        onFinish: $.noop,
        beforePageChange: $.noop,
        onPageChange: $.noop,
        onShowMore: $.noop,
        onFilterChange: $.noop,
        afterFilterInit: $.noop,
        init: function (params) {
            var _self = this;

            if (_self.element === null || _self.element.length === 0) {
                throw new Error('No filter element set.');
            }

            if (typeof params.totalProducts !== 'number' ) {
                throw new Error('totalProducts parameter must be set and a valid positive integer.');
            }

            if (typeof params.productTemplate !== 'string' ) {
                throw new Error('productTemplate must be a valid DOM selector.');
            }

            if (typeof params.productsContainer !== 'string' ) {
                throw new Error('productsContainer must be a valid DOM selector.');
            }

            _self.DEBUG = params.DEBUG || false;
            _self.startTimer();
            _self.onStart();

            _self.totalProducts = params.totalProducts;
            _self.totalPerPage = params.pageSize || 24;
            _self.totalPages = Math.ceil(_self.totalProducts / _self.maxPerPage);
            _self.productTemplate = Handlebars.compile($(params.productTemplate).html());
            _self.productsContainerSelector = params.productsContainer;
            _self.productCountElement = params.productCountElement;
            _self.scrollableContainer = params.scrollableContainer || window;
            _self.enableColourMappings = params.enableColourMappings || false;
            _self.sizeMappings = params.sizeMappings || {};
            _self.hideUnavailableProducts = params.hideUnavailableProducts || false;
            _self.hideUnavailableFilterOptions = params.hideUnavailableFilterOptions || false;
            _self.tagWhitelist = params.tagWhitelist || null;
            _self.tagBlacklist = params.tagBlacklist || null;
            _self.optionBlacklist = params.optionBlacklist || null;
            _self.pagination.selector = params.paginationContainer || null;
            _self.pagination.nextText = params.paginationNextText || 'Next';
            _self.pagination.prevText = params.paginationPrevText || 'Previous';
            _self.pagination.optional = params.paginationOptional || false;
            _self.onStart = params.onStart || $.noop;
            _self.onFinish = params.onFinish || $.noop;
            _self.beforePageChange = params.beforePageChange || $.noop;
            _self.onPageChange = params.onPageChange || $.noop;
            _self.onShowMore = params.onShowMore || $.noop;
            _self.onFilterChange = params.onFilterChange || $.noop;
            _self.afterFilterInit= params.afterFilterInit || $.noop;
            _self.optionOrder = params.optionOrder || null;
            _self.generateCachePath();
            _self.initQuery();
            if (!_self.initCache()) {
                _self.getProducts().done(function () {
                    _self.setCache();
                    _self.finalize();
                });
            } else {
                _self.finalize();
            }
        },
        finalize: function () {
            this.log('Finalize filter');

            this.buildFilter();
            if (this.isFiltering()) {
                this.log('Apply filter');
                this.applyFilter();
            } else {
                this.log('Not currently filtering');
                this.refreshPagination();
                if (!this.pageSet && this.pagination.optional) {
                    this.productsDisplayed = this.productsFiltered.slice(this.totalPerPage * (this.params.page - 1), this.totalPerPage * this.params.page);
                }
            }

            this.onFinish();
            this.endTimer();
        },
        initWithSelector: function (elementSelector, params) {
            this.element = $(elementSelector);
            this.init(params);
        },
        initWithElement: function (element, params) {
            this.element = element;
            this.init(params);
        },
        initCache: function () {
            if (this.isSearching()) {
                return false;
            }

            var cacheJSON = window.sessionStorage[this.cachePath];
            if (cacheJSON) {
                var productStore =  this.parseJSON(cacheJSON);
                if (Date.now() < productStore.expiry) {
                    this.log('Using cached products.');
                    var _processed = {};
                    this.products = this.productsFiltered = productStore.products.filter(function (product) {
                        if (_processed['' + product.id]) {
                            return false;
                        }
                        _processed['' + product.id] = true;
                        return true;
                    });


                    return true;
                } else {
                    this.log('Product cache invalidated');
                    delete window.sessionStorage[this.cachePath];
                }
            }

            return false;
        },
        setCache: function () {
            var _self = this;

            if (!_self.isSearching()) {
                this.products = this.products.map(function (p) {
                    return _self.objectOmit(['body_html', 'created_at', 'updated_at'], p);
                });

                var productStore = _self.serializeJSON({
                    expiry: Date.now() + _self.expiryOffset,
                    products: _self.products
                });

                try {
                    window.sessionStorage[this.cachePath] = productStore;
                } catch (e) {
                    console.error('Failed to cache products.');
                }
            }
        },
        initQuery: function () {
            var _params = this.getQueryParams();
            this.filter = this.objectExtend({ option: {}, colour: {}, tag: {} }, _params.filter);
            if (_params.page) {
                this.params.page = _params.page;

                if (this.params.page > 1) {
                    this.pageSet = true;
                }
            } else {
                this.params.page = 1;
            }

            if (_params.q) {
                this.params.q = _params.q;
            }

            if (_params.sort_by && _params.sort_by !== 'best-selling') {
                this.params.sort_by = _params.sort_by;
            }
        },
        getProducts: function () {
            var _self = this;
            var dfd = $.Deferred();

            var _pages = [];
            var searchPath = _self.getSearchPath();
            for (var page = 1; page < (_self.totalPages + 1); page++) {
                // Must execute inside a closure to ensure the '_page' variable is accurate upon resolved promise.
                (function (_page) {
                    $.get(searchPath, _self.getSearchParams(_page)).done(function (response) {
                        _pages.push({
                            page: _page,
                            products: (_self.isSearching() ? response : response.products)
                        });

                        // This must be the last response.
                        if (_pages.length === _self.totalPages) {
                            _pages.sort(function (a, b) {
                                if (a.page > b.page) {
                                    return 1;
                                } else if (a.page < b.page) {
                                    return -1;
                                }

                                return 0;
                            });

                            var _products = [];
                            for (var i = 0; i < _self.totalPages; i++) {
                                _products = _products.concat(_pages[i].products);
                            }

                            var _processed = {};
                            _self.products = _self.productsFiltered = _products.filter(function (product) {
                                if (_processed['' + product.id]) {
                                    return false;
                                }
                                _processed['' + product.id] = true;
                                return true;
                            });
                            _self.convertSearchPrices();

                            dfd.resolve();
                        }
                    });
                })(page);
            }

            return dfd.promise();
        },
        buildFilter: function () {
            var _self = this;
            var _filter = {
                price: {
                    price_max: 0,
                    price_min: 0,
                    name: 'Price',
                    type: 'price'
                }
            };
            _self.colourMappings = {};

            for (var ip = 0, lp = _self.products.length; ip < lp; ip++) {
                var product = _self.products[ip];

                var vl = [{}, {}, {}];
                for (var iv = 0, lv = product.variants.length; iv < lv; iv++) {
                    var variant = product.variants[iv];

                    vl[0]['' + variant.option1] = variant.available;
                    vl[1]['' + variant.option2] = variant.available;
                    vl[2]['' + variant.option3] = variant.available;

                    var _price = parseFloat(variant.price);
                    if (!isNaN(_price)) {
                        if (_price > _filter.price.price_max) {
                            _filter.price.price_max = _price;
                        }
                    }
                }

                for (var io = 0, lo = product.options.length; io < lo; io++) {
                    var option = product.options[io];

                    var values = [];
                    if (_self.hideUnavailableFilterOptions) {
                        try {
                            for (var ivl = 0, lvl = option.values.length; ivl < lvl; ivl++) {
                                var v = option.values[ivl];
                                if (vl[option.position - 1]['' + v] === true) {
                                    values.push(v);
                                }
                            }
                        } catch (e) {
                            // Must be searching.
                        }
                    } else {
                        values = option.values;
                    }

                    if (~(option.name || '').trim().toLowerCase().indexOf('size')) {
                        values = values.map(function (n) {
                            return _self.getSize.apply(_self, [n]);
                        });
                    }

                    if (_self.optionBlacklist !== null && ~_self.optionBlacklist.indexOf(option.name)) {
                        continue;
                    }

                    if (!_self.isSearching()) {
                        var optionType = _self.getFilterType(option);
                        if (_self.enableColourMappings && optionType === 'colour') {
                            continue;
                        }

                        if (typeof _filter[option.name] === 'undefined') {
                            _filter[option.name] = {
                                name: option.name,
                                values: values,
                                type: _self.getFilterType(option)
                            };
                        } else {
                            _filter[option.name].values = _self.arrayUnion(_filter[option.name].values, values);
                        }
                    } else {
                        // Unimplemented
                    }
                }

                var _tags = product.tags.filter(function(a) {
                    return ~a.indexOf(':');
                });

                if (_self.hideUnavailableFilterOptions) {
                    if (product.variants.filter(function (v) {return v.available;}).length === 0) {
                        continue;
                    }
                }

                if (_tags.length > 0) {
                    for (var it = 0, lt = _tags.length; it < lt; it++) {
                        var tag = _tags[it];
                        var _parts = tag.split(':').map(function (n) {
                            return n.trim();
                        });

                        if (_parts.length === 2) {
                            if (_self.tagWhitelist !== null && !~_self.tagWhitelist.indexOf(_parts[0])) {
                                continue;
                            }

                            if (_self.tagBlacklist !== null && ~_self.tagBlacklist.indexOf(_parts[0])) {
                                continue;
                            }

                            if (typeof _filter[_parts[0]] === 'undefined') {
                                _filter[_parts[0]] = {
                                    name: (_parts[0].substr(0, 1).toUpperCase() + _parts[0].substr(1).toLowerCase()).split('-').join(' '),
                                    values: [_parts[1]],
                                    type: 'tag'
                                }
                            } else {
                                _filter[_parts[0]].values = _self.arrayUnion(_filter[_parts[0]].values, [_parts[1]])
                            }
                        } else if (_self.enableColourMappings && _parts.length === 3 && _parts[0].toLowerCase() === _self.colourOptionName.toLowerCase()) {
                            if (typeof _self.colourMappings[_parts[2]] === 'undefined') {
                                _self.colourMappings[_parts[2]] = [_parts[1]];

                                if (typeof _filter[_self.colourOptionName] === 'undefined') {
                                    _filter[_self.colourOptionName] = {
                                        name: _self.colourOptionName,
                                        values: [_parts[2]],
                                        type: 'colour'
                                    };
                                } else {
                                    _filter[_self.colourOptionName].values = _self.arrayUnion(_filter[_self.colourOptionName].values, [_parts[2]]);
                                }
                            } else {
                                _self.colourMappings[_parts[2]] = _self.arrayUnion(_self.colourMappings[_parts[2]], [_parts[1]]);
                            }
                        }
                    }
                }
            }


            for (var key in _filter) {
                if (_filter.hasOwnProperty(key) && typeof _filter[key].values !== 'undefined') {
                    _filter[key].values.sort(_self.naturalCompare);
                }
            }

            _self.buildHTML(_filter);
        },
        buildHTML: function (filter) {
            var _self = this;
            var $html = $('<ul class="advanced-filter" />');
            _self.element.html($html);

            var _keys = [];
            for (var key in filter) {
                if (filter.hasOwnProperty(key)) {
                    _keys.push(key);
                }
            }

            if (_self.optionOrder === null) {
                _keys.sort(_self.naturalCompare);
            } else {
                _keys = _self.optionOrder(_keys);
            }

            for (var i = 0, l = _keys.length; i < l; i++) {
                _self.buildItemHTML(filter, _keys[i], $html);
            }
        },
        buildItemHTML: function (filter, key, $html) {
            var _self = this;
            var item = filter[key];

            if (typeof item === 'undefined') {
                return;
            }

            var $li = $('<li data-type="' + item.type + '" unselectable="on"><div class="filter-option-title">' + item.name + '</div><div class="filter-option-cont"></div></li>');
            var $header = $li.find('.filter-option-title');
            var $content = $li.find('.filter-option-cont');
            $html.append($li);

            switch (item.type) {
                case 'price':
                    var $slider = $('<div id="price_rangeslider" />');
                    $content.append($slider);
                    $slider.ionRangeSlider({
                        type: 'double',
                        grid: true,
                        min: item.price_min,
                        max: item.price_max,
                        from: _self.filter.price_min || item.price_min,
                        to: _self.filter.price_max || item.price_max,
                        step: 10,
                        prefix: _self.currencyPrefix,
                        prettify_separator: ',',
                        force_edges: true,
                        onFinish: function (data) {
                            _self.filter.price_min = parseFloat(data.from);
                            _self.filter.price_max = parseFloat(data.to);
                            _self.applyFilter();
                        }
                    });
                    break;
                case 'option':
                case 'tag':
                case 'colour':
                    var $valuesList = $('<ul class="filter-option-vals type-' + item.type + '" />');
                    $content.append($valuesList);

                    for (var io = 0, lo = item.values.length; io < lo; io++) {
                        (function (value, filterKey) {
                            var $valueItem = $('<li />', {
                                'data-value':  value
                            });

                            var checked = '';
                            var values = _self.filter[item.type][filterKey];
                            if (typeof values !== 'undefined' && ~values.indexOf(value)) {
                                checked = ' checked'
                            }
                            var safeName = item.type + '_' + value.replace(/"/g, '').replace(/\s+/g, '_');
                            var $checkbox = $('<input type="checkbox" id="' + safeName + '"' + checked + ' />');
                            var $label = $('<label for="' + safeName + '">' + value + '</label>');

                            $valueItem.append($checkbox);
                            $valueItem.append($label);
                            $valuesList.append($valueItem);

                            $checkbox.change(function () {
                                var _f = _self.filter[item.type][filterKey] || [];

                                if ($(this).is(':checked')) {
                                    _f = _self.arrayUnion(_f, [ value ]);
                                } else {
                                    _f = _self.arrayDifference(_f, [ value ]);
                                }

                                _self.filter[item.type][filterKey] = _f;
                                _self.applyFilter();
                            });
                        })(item.values[io], key)
                    }
                    break;
            }

            $header.click(function() {
                var $this = $(this);

                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                    $this.siblings('.filter-option-cont').stop().slideUp(200);
                } else {
                    $li.addClass('active');
                    $this.siblings('.filter-option-cont').stop().slideDown(200);
                }
            });
        },
        // Updates productsFiltered and productsDisplayed without affecting page
        initDisplayedProducts: function(exclude_products) {
            this.log('initDisplayedProducts');
            var _self = this;
            var _processed = []; // Prevent duplicates.
            _self.productsFiltered = _self.products.filter(function (product) {
                if (_processed['' + product.id]) {
                    return false;
                }
                if (exclude_products.includes('' + product.id))
                    return false;
                _processed['' + product.id] = true;

                return _self.removeUnavailable(_self, product);
            });
            _self.productsDisplayed = _self.productsFiltered.slice(_self.totalPerPage * (_self.params.page - 1), _self.totalPerPage * _self.params.page);
            _self.afterFilterInit(_self);
        },
        removeUnavailable: function (_self, product) {
            this.log('remove unavail');
            if (_self.hideUnavailableProducts) {
                var _unavailable = true;
                for (var i = 0, l = product.variants.length; i < l; i++) {
                    var variant = product.variants[i];
                    if (variant.available) {
                        _unavailable = false;
                        break;
                    }
                }

                if (_unavailable) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        applyFilter: function () {
            var _self = this;

            if (_self.oldTotalPerPage) {
                _self.totalPerPage = _self.oldTotalPerPage;
                _self.oldTotalPerPage = null;
            }

            var _processed = []; // Prevent duplicates.
            _self.productsFiltered = _self.products.filter(function (product) {
                if (_processed['' + product.id]) {
                    return false;
                }
                _processed['' + product.id] = true;

                return _self.matchFilterDown(_self, product);
            });

            if (_self.params.sort_by !== '') {
                switch (_self.params.sort_by) {
                    case 'price-ascending':
                        _self.productsFiltered.sort(function (a, b) {
                            var aPrice = parseFloat(a.variants[0].price);
                            if (aPrice <= 0) aPrice = Infinity;

                            var bPrice = parseFloat(b.variants[0].price);
                            if (bPrice <= 0) bPrice = Infinity;

                            return aPrice - bPrice;
                        });
                        break;
                    case 'price-descending':
                        _self.productsFiltered.sort(function (a, b) {
                            var aPrice = parseFloat(a.variants[0].price);
                            if (aPrice <= 0) aPrice = Infinity;

                            var bPrice = parseFloat(b.variants[0].price);
                            if (bPrice <= 0) bPrice = Infinity;

                            return bPrice - aPrice;
                        });
                        break;
                    case 'title-ascending':
                        _self.productsFiltered.sort(function (a, b) {
                            return a.title.localeCompare(b.title);
                        });
                        break;
                    case 'title-descending':
                        _self.productsFiltered.sort(function (a, b) {
                            return b.title.localeCompare(a.title);
                        });
                        break;
                    case 'created-ascending':
                        _self.productsFiltered.sort(function (a, b) {
                            return new Date(a.published_at) - new Date(b.published_at);
                        });
                        break;
                    case 'created-descending':
                        _self.productsFiltered.sort(function (a, b) {
                            return new Date(b.published_at) - new Date(a.published_at);
                        });
                        break;
                }
            }

            _self.showPage(1);
            _self.onFilterChange(_self);
        },
        matchFilterDown: function (_self, product) {
            var _matches = {};

            if (_self.hideUnavailableProducts) {
                var _unavailable = true;
                for (var i = 0, l = product.variants.length; i < l; i++) {
                    var variant = product.variants[i];
                    if (variant.available) {
                        _unavailable = false;
                        break;
                    }
                }

                if (_unavailable) {
                    return false;
                }
            }

            // Filter by options.
            for (var key in _self.filter.option) {
                if (_self.filter.option.hasOwnProperty(key)) {
                    var value = _self.filter.option[key];
                    var newVals = [];
                    if (~key.trim().toLowerCase().indexOf('size')) {
                        for (var iv = 0, lv = value.length; iv < lv; iv++) {
                            var n = _self.getSizeReverse(value[iv]);
                            if (value.indexOf(n) === -1 && newVals.indexOf(n) === -1) {
                                newVals.push(n);
                            }
                        }
                    }

                    value = value.concat(newVals);

                    if (value.length > 0) {
                        for (var iv = 0, lv = product.options.length; iv < lv; iv++) {
                            _matches['opt_' + key] = false;
                            var option = product.options[iv];
                            if (option.name === key) {
                                if (_self.hideUnavailableProducts) {
                                    var _opt_unavailable = true;
                                    for (var hiv = 0, hlv = product.variants.length; hiv < hlv; hiv++) {
                                        var h_variant = product.variants[hiv];

                                        if (typeof value === 'string') {
                                            if (h_variant['option' + option.position] === value) {
                                                if (h_variant.available) {
                                                    _opt_unavailable = false;
                                                    break;
                                                }
                                            }
                                        } else {
                                            for (var hivv = 0, hlvv = value.length; hivv < hlvv; hivv++) {
                                                var val = value[hivv];
                                                if (h_variant['option' + option.position] === val) {
                                                    if (h_variant.available) {
                                                        _opt_unavailable = false;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if (_opt_unavailable) {
                                        continue;
                                    }
                                }

                                for (var io = 0, lo = value.length; io < lo; io++) {
                                    var o = value[io];

                                    for (var inn = 0, ln = option.values.length; inn < ln; inn++) {
                                        var n = option.values[inn];
                                        if (o === n) {
                                            _matches['opt_' + key] = true;
                                            break;
                                        }
                                    }

                                    if (_matches['opt_' + key]) {
                                        break;
                                    }
                                }

                                break;
                            }
                        }
                    }
                }
            }


            // Filter by colour.
            if (_self.enableColourMappings) {
                for (var iv = 0, lv = product.options.length; iv < lv; iv++) {
                    var option = product.options[iv];
                    if (_self.getFilterType(option) === 'colour') {
                        for (var key in _self.filter.colour) {
                            if (_self.filter.colour.hasOwnProperty(key)) {
                                var value = _self.filter.colour[key];
                                if (value.length > 0) {

                                    _matches['col_' + option.name] = false;

                                    for (var ic = 0, lc = value.length; ic < lc; ic++) {
                                        var shortColour = value[ic];
                                        var mapping = _self.colourMappings[shortColour];
                                        if (mapping) {
                                            for (var ic = 0, lc = option.values.length; ic < lc; ic++) {
                                                var c = option.values[ic];
                                                if (~mapping.indexOf(c)) {
                                                    _matches['col_' + option.name] = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (~mapping.indexOf(c)) {
                                            _matches['col_' + option.name] = true;
                                            break;
                                        }
                                    }

                                    if (_matches['col_' + option.name]) {
                                        break;
                                    }
                                }
                            }
                        }

                        if (_matches['col_' + option.name]) {
                            break;
                        }
                    }
                }
            }


            // Filter by tags.
            var _tags = {};
            for (var it = 0, lt = product.tags.length; it < lt; it++) {
                var _tag = product.tags[it];
                var _parts = _tag.split(':').map(function (t) {
                    return t.trim();
                });

                if (_parts.length === 2) {
                    if (!_tags[_parts[0]]) {
                        _tags[_parts[0]] = [];
                    }

                    _tags[_parts[0]].push(_parts[1]);
                }
            }

            for (var key in _self.filter.tag) {
                if (_self.filter.tag.hasOwnProperty(key)) {
                    var value = _self.filter.tag[key];
                    if (value.length > 0) {
                        _matches['tag_' + key] = false;

                        if (_tags[key]) {
                            for (var it = 0, lt = value.length; it < lt; it++) {
                                var tag = value[it];
                                if (~_tags[key].indexOf(tag)) {
                                    _matches['tag_' + key] = true;
                                    break;
                                }
                            }
                        }

                        if (_matches['tag_' + key]) {
                            break;
                        }
                    }
                }
            }

            if (_self.filter.price_min || _self.filter.price_max) {
                _matches['price'] = true;

                for (var iv = 0, lv = product.variants.length; iv < lv; iv++) {
                    var variant = product.variants[iv];
                    var price = parseFloat(variant.price);

                    if (!isNaN(price)) {
                        _matches['price'] &= (price >= (_self.filter.price_min || 0));
                        _matches['price'] &= (price <= (_self.filter.price_max || Infinity));

                        if (_matches['price']) {
                            break;
                        }
                    }
                }
            }

            for (var key in _matches) {
                if (_matches.hasOwnProperty(key)) {
                    if (!_matches[key]) return false;
                }
            }

            return true;
        },
        showPage: function (page, scrollToTop) {
            var _self = this;

            if (typeof scrollToTop === 'undefined') scrollToTop = false;

            _self.pageSet = false;
            _self.beforePageChange(_self, _self.params.page);

            _self.params.page = page;
            var urlParams = {
                page: _self.params.page,
                q: _self.params.q,
                type: _self.params.type
            };
            if (_self.params.sort_by !== 'best-selling') {
                urlParams.sort_by = _self.params.sort_by;
            }

            var cleaned = $.extend({}, _self.cleanUrlParams(urlParams), {filter: _self.cleanUrlParams(_self.filter)});
            _self.setUrlParams(cleaned);

            _self.productsDisplayed = _self.productsFiltered.slice(_self.totalPerPage * (_self.params.page - 1), _self.totalPerPage * _self.params.page);
            var html = $(_self.productTemplate({
                products: _self.productsDisplayed
            }));

            if (!_self.productsContainer) _self.productsContainer = $(_self.productsContainerSelector);
            _self.productsContainer.html(html);
            _self.refreshPagination();
            _self.onPageChange(_self, page);

            if (scrollToTop) {
                $(_self.scrollableContainer).scrollTop(0);
            }
        },
        showAllProducts: function () {
            this.oldTotalPerPage = this.totalPerPage;
            this.totalPerPage = this.productsFiltered.length;
            this.showPage(1, true);
        },
        showMoreProducts: function (number) {
            var _self = this;

            if (typeof number === 'undefined') {
                number = _self.totalPerPage;
            }

            if (_self.productsDisplayed.length < _self.productsFiltered.length) {
                var _end = Math.min(_self.productsDisplayed.length + number, _self.productsFiltered.length);
                var _new = _self.productsFiltered.slice(_self.productsDisplayed.length, _end);
                _self.productsDisplayed = _self.productsFiltered.slice(0, _end);
                var html = $(_self.productTemplate({
                    products: _new
                }));

                if (!_self.productsContainer) _self.productsContainer = $(_self.productsContainerSelector);
                _self.productsContainer.append(html);
                _self.refreshPagination();
                _self.onShowMore(_self, _new, html);

                if (_end < _self.productsFiltered.length) {
                    _self.log('There are still more products.');
                    return true;
                } else {
                    _self.log('There are no more products.');
                    return false;
                }
            } else {
                _self.log('There are no more products.');
                return false;
            }
        },
        clearFilter: function () {
            this.filter = { option: {}, colour: {}, tag: {} };
            this.buildFilter();
            this.applyFilter();
        },
        isFiltering: function () {
            this.log('Testing if filtering');
            return (this.filter.price_max || this.filter.price_min || !$.isEmptyObject(this.filter.option) || !$.isEmptyObject(this.filter.tag) || !$.isEmptyObject(this.filter.colour));
        },
        isSearching: function () {
            return /\/search(\?|$)/.test(window.location.href);
        },
        convertSearchPrices: function () {
            if (this.isSearching()) {
                var keys = ['compare_at_price', 'compare_at_price_max', 'compare_at_price_min', 'price', 'price_max', 'price_min'];
                this.products = this.products.map(function (product) {
                    product.variants = product.variants.map(function (variant) {
                        for (var iv = 0; iv < 6; iv++) {
                            var kv = keys[iv];
                            if (variant[kv] !== null) {
                                if (variant[kv] > 0) {
                                    variant[kv] = '' + (variant[kv] / 100);
                                } else {
                                    variant[kv] = '0';
                                }
                            }
                        }

                        return variant;
                    });
                    return product;
                });
            }
        },
        refreshPagination: function () {
            var _self = this;

            if (!_self.pagination.element && (!_self.pageSet && _self.pagination.optional)) {
                _self.log('No need to init pagination.');
                return;
            }
            
            _self.pages = Math.ceil(_self.productsFiltered.length / _self.totalPerPage);
            $(_self.productCountElement).text(_self.productsFiltered.length)

            if (!_self.pagination.element) {
                _self.pagination.element = $(_self.pagination.selector);
            }

            let paginationHTML = '';

            if (_self.params.page > 1) {
                paginationHTML += `<li><a onClick="shopfilter.showPage(${parseInt(_self.params.page) - 1}, true)"><i class="wb-icon wb-chevron-left"></i></a></li>`
                paginationHTML += `<li><a onClick="shopfilter.showPage(${parseInt(_self.params.page) - 1}, true)">${parseInt(_self.params.page) - 1}</a></li>`
            }

            if (_self.pages > 1) {
                paginationHTML += `<li class="active"><span>${_self.params.page}</span></li>`
            }

            if (_self.params.page < _self.pages) {
                paginationHTML += `<li><a onClick="shopfilter.showPage(${parseInt(_self.params.page) + 1}, true)">${parseInt(_self.params.page) + 1}</a></li>`
                paginationHTML += `<li><a onClick="shopfilter.showPage(${parseInt(_self.params.page) + 1}, true)"><i class="wb-icon wb-chevron-right"></i></a></li>`
            }

            _self.pagination.element.empty().html(paginationHTML)
        },
        setUrlParams: function (params) {
            var t = $.param(params), p = '';
            if (t !== '') {
                p = '?' + decodeURI(t);
            }

            window.history.pushState({}, '', p);
        },
        cleanUrlParams: function (params) {
            var n = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var value = params[key];
                    if (value) {
                        n[key] = value;
                    }
                }
            }

            return n;
        },
        getFilterType: function (option) {
            if (~['color', 'colour', 'coluor'].indexOf(option.name.trim().toLowerCase())) {
                return 'colour'
            }

            return 'option';
        },
        getSize: function (size) {
            if (typeof this.sizeMappings[size] !== 'undefined') {
                return '' + this.sizeMappings[size];
            }

            return size;
        },
        getSizeReverse: function (size) {
            for (var key in this.sizeMappings) {
                if (this.sizeMappings.hasOwnProperty(key)) {
                    var value = this.sizeMappings[key];
                    if (('' + value) == size) {
                        return key;
                    }
                }
            }

            return size;
        },
        generateCachePath: function () {
            this.cachePath = window.location.pathname;
        },
        getSearchPath: function () {
            if (this.isSearching()) {
                return 'search.json';
            } else {
                return window.location.pathname + '/products.json';
            }
        },
        getSearchParams: function (page) {
            if (this.isSearching()) {
                return { limit: this.maxPerPage, page: page, type: 'product', view: 'json', q: this.params.q };
            } else {
                return { limit: this.maxPerPage, page: page };
            }
        },
        getQueryParams: function () {
            var s = window.location.search;
            if (s[0] === '?') {
                s = s.substr(1);
            }

            return this.queryDeparam(s);
        },
        parseJSON: function (json) {
            return JSON.parse(json);
        },
        serializeJSON: function (obj) {
            return JSON.stringify(obj);
        },
        queryDeparam: function(n, a) {
            var b = {}, f = {'true': !0, 'false': !1, 'null': null};
            $.each(n.replace(/\+/g, " ").split("&"), function(d, e) {
                var g, c = e.split("=");
                g = decodeURIComponent(c[0]);
                var p = b, m = 0, k = g.split("]["), l = k.length - 1;
                /\[/.test(k[0]) && /\]$/.test(k[l]) ? (k[l] = k[l].replace(/\]$/, ""), k = k.shift().split("[").concat(k), l = k.length - 1) : l = 0;
                if (2 === c.length) {
                    if (c = decodeURIComponent(c[1]), a && (c = c && !isNaN(c) ? +c : "undefined" === c ? void 0 : void 0 !== f[c] ? f[c] : c), l) {
                        for (;m <= l;m++) {
                            g = "" === k[m] ? p.length : k[m], p = g = p[g] = m < l ? p[g] || (k[m + 1] && isNaN(k[m + 1]) ? {} : []) : c;
                        }
                    } else {
                        $.isArray(b[g]) ? b[g].push(c) : b[g] = void 0 !== b[g] ? [b[g], c] : c;
                    }
                } else {
                    g && (b[g] = a ? void 0 : "");
                }
            });
            return b;
        },
        arrayUnion: function (x, y) {
            var obj = {};
            for (var xi = x.length - 1; xi >= 0; --xi) {
                obj[x[xi]] = x[xi];
            }
            for (var yi = y.length - 1; yi >= 0; --yi) {
                obj[y[yi]] = y[yi];
            }

            var res = [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    res.push(obj[key]);
                }
            }

            return res;
        },
        arrayDifference: function (x, y) {
            return x.filter(function(a) {
                return y.indexOf(a) < 0;
            });
        },
        objectExtend: function (x, y) {
            return $.extend(x, y);
        },
        objectOmit: function (keys, obj) {
            var copy = {};
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && keys.indexOf(key) === -1) {
                    copy[key] = obj[key];
                }
            }

            return copy;
        },
        naturalCompare: function (a, b) {
            var ax = [], bx = [];

            a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
            b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

            while (ax.length && bx.length) {
                var an = ax.shift();
                var bn = bx.shift();
                var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
                if (nn) return nn;
            }

            return ax.length - bx.length;
        },
        startTimer: function () {
            if (this.DEBUG) this.timer = Date.now();
        },
        endTimer: function () {
            if (this.DEBUG) {
                var offset = Date.now() - this.timer;
                console.info('Filter processed in ' + offset + 'ms.')
            }
        },
        log: (function (message) {
            if (this.DEBUG) console.info(message);
        })
    };

    window.ShopifyFilter = ShopifyFilter;

    // Allow instantiation via jQuery.
    $.fn.shopifyFilter = function (params) {
        return new ShopifyFilter(this, params);
    };
})(jQuery);



/* ============================================== HANDLEBARS HELPERS ============================================== */
Handlebars.registerHelper('productLink', function (handle) {
    if (window.location.pathname !== '/search' && window.location.pathname !== '/') {
        return window.location.pathname + '/products/' + handle;
    } else {
        return '/products/' + handle;
    }
});


Handlebars.registerHelper('productPrice', function (product) {
    var price = null;
    var priceFloat = null;
    var priceVaries = false;
    var compareAtPriceVaries = false;
    var minCompareAtPrice = null;
    var minCompareAtPriceFloat = null;
    var isDiscounted = false;
    var isAvailable = false;
    for (var i = 0, l = product.variants.length; i < l; i++) {
        var thisVariant = product.variants[i];
        if (thisVariant.available) {
            isAvailable = true;
        }

        var compareAtPriceFloat = parseFloat(thisVariant.compare_at_price);
        if (thisVariant.compare_at_price !== null && minCompareAtPrice === null || (thisVariant.compare_at_price !== null && compareAtPriceFloat < minCompareAtPriceFloat)) {
            minCompareAtPrice = thisVariant.compare_at_price;
            minCompareAtPriceFloat = compareAtPriceFloat;
            isDiscounted = true;
        }

        if (thisVariant.compare_at_price !== null && minCompareAtPriceFloat !== compareAtPriceFloat) {
            compareAtPriceVaries = true;
        }

        var variantPriceFloat = parseFloat(thisVariant.price);
        if (price === null || variantPriceFloat < price) {
            price = thisVariant.price;
            priceFloat = variantPriceFloat;
        }

        if (priceFloat !== variantPriceFloat) {
            priceVaries = true;
        }
    }

    if (!isAvailable) {
        return new Handlebars.SafeString('<div class="product-price discounted"><div><span class="sold-out">Sold Out</span></div></div>');
    }

    if (isDiscounted) {
        var salehtml = '<div class="product-price discounted"><div>';
        if (compareAtPriceVaries) {
            salehtml += '<span class="compare-at-price">From ' + Shopify.formatMoney(minCompareAtPrice) + '</span>';
        } else {
            salehtml += '<span class="compare-at-price">' + Shopify.formatMoney(minCompareAtPrice) + '</span>';
        }
        salehtml += '<span class="price">' + Shopify.formatMoney(price) + '</span>';
        salehtml += '</div></div>';

        return new Handlebars.SafeString(salehtml);
    } else {
        var html = '<div class="product-price"><div>';
        if (priceVaries) {
            html += '<span class="price">From ' + Shopify.formatMoney(price) + '</span>';
        } else {
            html += '<span class="price">' + Shopify.formatMoney(price) + '</span>';
        }
        html += '</div></div>';

        return new Handlebars.SafeString(html);
    }
});


Handlebars.registerHelper('imageLink', function (link, options) {
    if (link) {
        if (link.src) {
            return Shopify.resizeImage(link.src, options.hash.size);
        } else {
            return Shopify.resizeImage(link, options.hash.size);
        }
    }
});


Handlebars.registerHelper('moneyFormat', function (price) {
    return Shopify.formatMoney(price);
});


Handlebars.registerHelper('hasColours', function (productOptions, options) {
    if (productOptions) {
        for (var i = 0, l = productOptions.length; i < l; i++) {
            var option = productOptions[i];
            if (option.name === 'Colour') {
                if (option.values.length > 1) {
                    return options.fn(this);
                }
                break;
            }
        }
    }

    return options.inverse(this);
});


Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
    if (arguments.length < 3) {
        throw new Error('Handlerbars Helper \'compare\' needs 2 parameters');
    }

    if (typeof lvalue === 'undefined' || typeof rvalue === 'undefined') {
        return false;
    }

    var operator = options.hash.operator || '==';
    var operators = {
        '==': function (l, r) {
            return l == r;
        },
        '===': function (l, r) {
            return l === r;
        },
        '!=': function (l, r) {
            return l != r;
        },
        '<': function (l, r) {
            return parseFloat(l) < parseFloat(r);
        },
        '>': function (l, r) {
            return parseFloat(l) > parseFloat(r);
        },
        '<=': function (l, r) {
            return parseFloat(l) <= parseFloat(r);
        },
        '>=': function (l, r) {
            return parseFloat(l) >= parseFloat(r);
        },
        'typeof': function (l, r) {
            return typeof l === r;
        },
        'contains': function (l, r) {
            return ~l.indexOf(r);
        },
        '!contains': function (l, r) {
            return !(~l.indexOf(r));
        }
    };

    if (!operators[operator]) {
        throw new Error('Handlerbars Helper \'compare\' doesn\'t know the operator ' + operator);
    }

    var result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

